"use client";

import { ComponentProps, useMemo } from "react";
import {
  BMComponentsType,
  BMElevationType,
  BMPrimitives,
  BMText,
  useBMTheme,
} from "@traveloka/district-bloom";
import { StyleSheet } from "react-native";
import CalendarPairPicker from "../../../mobile/components/common/CalendarPicker/CalendarPairPicker";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import BMView from "../../View/BMView";

type Props = Omit<
  ComponentProps<typeof CalendarPairPicker>,
  "footerComponent" | "width" | "contentStyle"
>;

const CARD_WIDTH = 400;
const CALENDAR_HEIGHT = 552;

export default function CalendarPairPickerPopup(props: Props) {
  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();
  const { BMComponents, BMElevation } = useBMTheme();
  const styles = useMemo(
    () => createStyles(BMComponents, BMElevation),
    [BMComponents, BMElevation]
  );

  return (
    <BMView style={styles.card}>
      <CalendarPairPicker
        {...props}
        width={CARD_WIDTH}
        contentStyle={styles.calendarContent}
        footerComponent={
          <BMText
            variant="uiSmall"
            ink="BMStyleTextInkSecondary"
            style={styles.disclaimer}
          >
            {cr.dateRangeDisclaimer}
          </BMText>
        }
      />
    </BMView>
  );
}

const createStyles = (
  BMComponents: BMComponentsType,
  BMElevation: BMElevationType
) =>
  StyleSheet.create({
    card: {
      width: CARD_WIDTH,
      height: "100%",
      backgroundColor: BMComponents.BMStyleCardBgcolor,
      borderRadius: BMComponents.BMStyleCardRadiusCompact,
      overflow: "hidden",
      ...BMElevation.elevation2,
    },
    calendarContent: {
      height: CALENDAR_HEIGHT,
    },
    disclaimer: {
      paddingLeft: BMPrimitives.BMSize.md,
      paddingVertical: BMPrimitives.BMSize.md,
    },
  });
